export const LANGUAGE = '[Language]';

export const CHANGE_LOCALE = `${LANGUAGE} CHANGE_LOCALE`;
